import { render, staticRenderFns } from "./receipts.vue?vue&type=template&id=f96b2cbe"
import script from "./receipts.vue?vue&type=script&lang=js"
export * from "./receipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports